import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ViewLog from "../../../../../components/@schedulers/logs/ViewLog";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function LogViewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ViewLog 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       